import { ListingRealisations } from '@components/listing-realisations/models';
import { Block } from '@shared/models';

export const listingRealisationsMock = (data: ListingRealisations): Block<ListingRealisations> => ({
  type: 'listing-realisations',
  data,
});
